import { ITheme } from "../../utils/theme"

export const TableStyle = (theme: ITheme) => ({
  [theme.breakpoints.down('md')]: {
    ' .MuiTableCell-root': {
      maxWidth: '20ch',
      '&:first-of-type': {
        minWidth: 'auto'
      }
    }
  }
})

export const TablePaginationStyle = {
  '&.hide-per-page-options': {
    ' .MuiTablePagination-selectLabel': {
      display: 'none'
    },
    ' .MuiInputBase-root': {
      display: 'none'
    }
  }
}

export const TableHeadCellStyle = (theme: ITheme) => ({
  background: theme.palette.blue[900],
  color: 'white',
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  pt: 1,
  pb: 1,
  '&:first-of-type': {
    borderRightColor: 'transparent'
  }
})

export const TableBodyStyle = (theme: ITheme) => ({
  background: theme.palette.common.white,
  '& .WithBackground': {
    background: theme.palette.blue[100]
  },
})

export const TableCellStyle = (theme: ITheme) => ({
  pt: 1,
  pb: 1,
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  [theme.breakpoints.down('md')]: {
    pt: 0.5,
    pb: 0.5
  }
})

export const CollapsibleHeaderStyle = (theme: ITheme) => ({
  background: theme.palette.blue[300],
  pb: 1,
  pt: 1
})

export const CollapsibleCellStyle = (theme: ITheme) => ({
  background: theme.palette.success.main,
  pt: 1,
  pb: 1
})

export const PaginationStyle = {
  position: 'sticky',
  left: 0,
  '& .MuiPagination-ul': {
    justifyContent: 'center',
  },
  pt: 1,
  pb: 1
}

export const NoRecordsStyle = (theme: ITheme) => ({
  textAlign: 'center',
  padding: 1,
  borderRadius: '10px',
  color: theme.palette.grey.A200
});
